import { render, staticRenderFns } from "./app-menu.vue?vue&type=template&id=2baefcdd&scoped=true&"
import script from "./AppMenu.js?vue&type=script&lang=js&"
export * from "./AppMenu.js?vue&type=script&lang=js&"
import style0 from "./app-menu.vue?vue&type=style&index=0&id=2baefcdd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baefcdd",
  null
  
)

export default component.exports